import styled from 'styled-components';

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding-right: 0;
`;

export const DateText = styled.div`
  font-weight: ${({ selected }: { selected: any }) => (selected ? '600' : 'normal')};
  font-size: 12px;
  line-height: 16px;
  padding: 0 10px;
  cursor: pointer;
  background-color: ${({ selected }: { selected: any }) => (selected ? '#E9F3FD' : '#F6F6F6')};
  color: ${({ selected }: { selected: any }) => (selected ? '#1890ff' : 'black')};
  height: 100%;
  align-items: center;
  display: flex;

  &:hover {
    background: #e9f3fd;
    color: #1890ff;
  }

  border-right: 1px solid #dadada;

  &:last-child {
    border: 0;
  }
`;

export const Range = styled.div`
  margin-top: 50px;
  position: absolute;
`;

export const DateRange = styled.div`
  display: flex;
  flex-direction: column;
  background: #f6f6f6;
  border: 1px solid #dadada;
  border-radius: 6px;
  align-items: center;
  position: relative;
  height: 32px;
  box-sizing: border-box;

  .ant-picker.ant-picker-range {
    border: 0;
  }
`;

export const ModalMask = styled.div`
  position: fixed;
  inset: 0;
  margin: 0;
  opacity: var(--modal-light-opacity, 0.1);
  z-index: 70;
  background-color: rgb(0 0 0);
  background-color: var(--model-background, rgb(0 0 0));

  & + div {
    z-index: 71;
  }
`;

export const DisabledDate = styled.div`
  opacity: 0.45;
  pointer-events: none;
  font-size: 12px;
  line-height: 16px;
  padding: 0 5px;
  cursor: pointer;
  height: 100%;
  align-items: center;
  display: flex;
`;

export const DateIcon = styled.div`
  padding-left: 10px;
`;

export const LiveModeMarker = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  margin-right: 5px;
`;
